import { useQueryClient } from "@tanstack/react-query";

import API from "../../..";
import { useMutationWrapper } from "../../wrappers";
import { roomDetailsKey, roomListKey, updateRoomByMonitorIdKey } from "../room-query-keys";
import { useInternationalization, useNotification } from "@/lib/contexts";

export function useMutationUpdateRoomByMonitorId(
  monitorId: string,
  onSuccess?: (roomId: string) => void
) {
  const { t } = useInternationalization("pages.rooms.alerts.update-room");
  const { error } = useNotification();

  const queryClient = useQueryClient();

  const invalidateQueryKeys = (roomId?: string) => {
    if (roomId) {
      queryClient.invalidateQueries({ queryKey: roomDetailsKey(roomId) });
    }
    queryClient.invalidateQueries({ queryKey: roomListKey() });
  };

  const onError = async () => {
    error(t("error"));
  };

  const handleSuccess = async (roomId: string) => {
    if (onSuccess) {
      onSuccess(roomId);
    }
    invalidateQueryKeys(roomId);
  };

  const { mutate, isPending, isSuccess, isError } = useMutationWrapper({
    mutationKey: updateRoomByMonitorIdKey(monitorId),
    mutationFn: API.Rooms.updateRoomByMonitorId,
    onSuccess: handleSuccess,
    onError: onError,
  });

  return {
    mutate,
    isPending,
    isSuccess,
    isError,
  };
}
